import fetchApi from "../fetchApi";
export const GetWhiteLabel = async (subdomain) => {
  const options = {
    method: "GET",
    headers: new Headers({
      "Content-Type": "application/json",
    }),
    redirect: "follow",
  };

  return await fetchApi(`auth/white-label/${subdomain}`, options, true);
};
